module.exports = __webpack_public_path__ + "img/table-icon-fb.88a6db57.png";